import { BUSINESS_LINES_TABS } from 'containers/pricing/common/settings'

const migrations = {
  0: state => {
    return {
      ...state,
      CustomerDetails: {
        ...state.CustomerDetails,
        workOrders: {
          pagination: {
            size: 10,
          },
        },
      },
    }
  },
  1: state => {
    return {
      ...state,
      Route: {
        ...state.Route,
        bulkAssign: {
          isOpen: false,
          selectedRows: [],
        },
      },
    }
  },
  2: state => {
    return {
      ...state,
      persistentWorkOrdersReview: {
        routeIdList: [],
      },
    }
  },
  3: state => {
    return {
      ...state,
      Route: {
        ...state?.Route,
        filters: {
          ...state?.Route?.filters,
          businessId: null,
        },
      },
    }
  },
  4: state => {
    return {
      ...state,
      CustomerDetails: {
        ...state.CustomerDetails,
        configuredServices: {
          filters: {
            withDeactivated: true,
          },
        },
      },
    }
  },
  5: state => {
    return {
      ...state,
      persistentRentalFees: {
        ...state.persistentRentalFees,
        businessLine: state.persistentRentalFees?.businessLine ?? BUSINESS_LINES_TABS.ALL_BUSINESS_LINES,
      },
      persistentDisposalFees: {
        ...state.persistentDisposalFees,
        businessLine: state.persistentDisposalFees?.businessLine ?? BUSINESS_LINES_TABS.ALL_BUSINESS_LINES,
      },
      persistentLateFees: {
        ...state.persistentLateFees,
        businessLine: state.persistentLateFees?.businessLine ?? BUSINESS_LINES_TABS.ALL_BUSINESS_LINES,
      },
    }
  },
  // Routing-ops default flipped from `v2-pipeline` → `v1-bulk` so the
  // pre-routeOps single-call BE shape stays the production default on bulk
  // dialogs. Force-reset the persisted slice so existing sessions don't keep
  // routing through the multi-call pipeline.
  6: state => ({
    ...state,
    persistentRouteOpsStrategy: { strategy: 'v1-bulk' },
  }),
  // Re-run the v6 reset. Some sessions landed on persistConfig.version=6
  // before this migration body was deployed (intermediate builds bumped the
  // version without applying the strategy reset), so their `strategy` stayed
  // on `v2-pipeline`. v7 forces the reset for everyone regardless of the
  // version they came in on.
  7: state => ({
    ...state,
    persistentRouteOpsStrategy: { strategy: 'v1-bulk' },
  }),
  // The Board V2 "Move today only" (skipMoveConfirm) toggle was folded into the
  // shared Temporary mode. Carry a user's prior today-only preference over so
  // their moves stay non-permanent, then drop the dead field.
  8: state => {
    if (!state?.persistentBoardV2View?.skipMoveConfirm) return state
    const nextBoardV2View = { ...state.persistentBoardV2View }
    delete nextBoardV2View.skipMoveConfirm
    return {
      ...state,
      Route: { ...state.Route, isRouteChangesOnTemporaryMode: true },
      persistentBoardV2View: nextBoardV2View,
    }
  },
  // getStoredState ignores the whitelist, so a moved slice left inbound lets REHYDRATE overwrite the newer dedicated key.
  9: state => {
    const next = { ...state }
    delete next.persistentBoardV2Card
    delete next.persistentMasterRoute
    return next
  },
  // Selection is persisted as deselected ids now, so the legacy lists have to go or a stale one keeps hiding live accounts.
  10: state => {
    const dropLegacySelection = slice => {
      if (!slice?.filters) return slice
      const filters = { ...slice.filters }
      delete filters.selectedTags
      delete filters.selectedBillingProfiles
      return { ...slice, filters }
    }
    return {
      ...state,
      accounts: dropLegacySelection(state.accounts),
      locations: dropLegacySelection(state.locations),
    }
  },
  // A default an earlier build wrote, never a choice; kept, it reads as one and outranks the gate.
  11: state => ({
    ...state,
    persistentRouteOpsStrategy: { strategy: null },
  }),
  // A saved visibility model predates the Print only column, and the grid shows a column it has no key for.
  12: state => {
    const model = state?.persistentInvoices?.columnVisibilityModel
    if (!model || 'receivesPrintedCopy' in model) return state
    return {
      ...state,
      persistentInvoices: { ...state.persistentInvoices, columnVisibilityModel: { ...model, receivesPrintedCopy: false } },
    }
  },
}

export default migrations
